import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLeft, faRight } from '@fortawesome/pro-solid-svg-icons'
import { BudgetBuilderFooterProps } from '../types'
import { FINAL_STEP } from '../constants'

export const BudgetBuilderFooter = ({
  currentStep,
  onBack,
  onNext,
  isNextDisabled
}: BudgetBuilderFooterProps) => {
  if (currentStep === 0) {
    return null
  }

  const isFinalStep = currentStep === FINAL_STEP

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '16px 88px 16px 24px',
      borderTop: '1px solid #f0f0f0',
      backgroundColor: 'white',
      position: 'sticky',
      bottom: 0,
      zIndex: 10,
      boxShadow: '0 -2px 8px rgba(0,0,0,0.1)'
    }}>
      <Button
        size="large"
        onClick={onBack}
        icon={<FontAwesomeIcon icon={faLeft} />}
      >
        Back
      </Button>

      <Button
        type="primary"
        size="large"
        onClick={onNext}
        disabled={isNextDisabled}
        style={{
          backgroundColor: '#ff6b4a',
          borderColor: '#ff6b4a'
        }}
      >
        {isFinalStep ? 'Complete' : 'Next'}
        {!isFinalStep && <FontAwesomeIcon icon={faRight} style={{ marginLeft: '8px' }} />}
      </Button>
    </div>
  )
}
